import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import * as React from "react";
import { Checkbox } from "./checkbox";

export const LabeledCheckbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & { label: string; id: string }
>((props, ref) => (
  <div className="flex flex-row gap-2 items-center">
    <Checkbox {...props} ref={ref} id={props.id} />
    <label
      className="text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      htmlFor={props.id}
    >
      {props.label}
    </label>
  </div>
));
